import { FormControl, FormErrorMessage } from '@chakra-ui/form-control';
import { Input } from '@chakra-ui/input';
import { AspectRatio, Box, Heading, Text } from '@chakra-ui/layout';
import firebase from 'firebase';
import React, { useEffect, useState } from 'react';
import { UseFormReturn } from 'react-hook-form';
import {
  AdminCoursesModalForm,
  FirebaseCourseWithUid,
} from '../../../../types/types';

interface AdminCoursesModalUploadProps {
  form: UseFormReturn<AdminCoursesModalForm>;
  firebaseCourse: FirebaseCourseWithUid | undefined;
}

export const AdminCoursesModalUpload: React.FC<AdminCoursesModalUploadProps> =
  ({ form, firebaseCourse }) => {
    const { errors } = form.formState;
    const [imageUrl, setImageUrl] = useState('');

    useEffect(() => {
      const getUrl = () =>
        firebase
          .storage()
          .ref(firebaseCourse?.images.cover || '')
          .getDownloadURL()
          .then((url: string) => setImageUrl(url));

      getUrl();
    }, [firebaseCourse]);

    return (
      <section>
        <Heading mb={6} size="sm">
          Bilder-Upload
        </Heading>
        <FormControl isInvalid={!!errors.image} mb={6}>
          {firebaseCourse && firebaseCourse.images.cover && (
            <>
              <AspectRatio ratio={16 / 9} maxW="33%" mb={12}>
                <Box
                  bgImage={`url("${imageUrl}")`}
                  bgSize="cover"
                  my={6}
                  bgPosition="center"
                />
              </AspectRatio>

              <Text mt={3}>Möchtest du das bestehende Bild aktualisieren?</Text>
            </>
          )}
          <Input
            focusBorderColor="brand.500"
            type="file"
            py={10}
            textAlign="center"
            style={{ display: 'flex', justifyContent: 'center' }}
            accept="image/gif, image/jpeg, image/png"
            {...form.register('image', {
              validate: (file) =>
                (file && (!file[0] || (file[0] && file[0].size < 5242880))) ||
                false,
              required: false,
            })}
            placeholder="Bild auswählen"
          />
          <FormErrorMessage>
            {errors.image &&
              'Bitte lade nur Bilder hoch, die kleiner als 5 MB sind.'}
          </FormErrorMessage>
        </FormControl>
      </section>
    );
  };
